<template>
	<div class="add_backimg add_backimgTop clearfix">
		<div class="nav_list">
			<span class="primaryColor"><i class="el-icon-location-outline"></i>当前位置：</span>
			<span class="pointer" @click="toName('index')">首页<i class="el-icon-arrow-right"></i></span>
			<span class="pointer" @click="toName('news')">新闻资讯<i class="el-icon-arrow-right"></i></span>
			<span>新闻资讯详情</span>
		</div>
		<div class="content minheight clearfix">
			<div class="left_types">
				<div class="left_search">
					<div class="left_searchTitle">新闻资讯</div>
					<span class="left_searchEn">NEWS INFORMATION</span>
				</div>
				<div class="left_newsFilter clearfix">
					<div class="left_newsItem active">
						校内资讯
					</div>
				</div>
			</div>
			<div class="new_infoMain">
				<div class="new_rightBack">
					<span class="pointer" @click="toName('news')">
						<i class="el-icon-arrow-left"></i>返回新闻资讯
					</span>
					<el-button type="warning" class='r' size='small' @click="back = true" v-if='false'>公告反馈</el-button>
				</div>
				<div class="new_mainCont">
					<div class="new_mainTitle clearfix">
						<div class="new_listDate">
							<div class="new_listDay">{{detailInfo.releaseTime | spliceForDay}}</div>
							<div class="new_listMonth">{{detailInfo.releaseTime | spliceForYear}}</div>
						</div>
						<div class="new_listInfo clearfix">
							<div class="new_listTitle text-ellipsis">{{detailInfo.title}}</div>
							<div class="new_listOther clearfix">
								<div class="new_listIn">校内资讯</div>
								<div class="new_listNum">{{detailInfo.readCount || 0}}人已读</div>
							</div>
						</div>
					</div>
					<div class="new_mainHtml">
						<div v-html='detailInfo.context'></div>
					</div>
					<div class="new_mainPublish clearfix">
						<div class="new_publishCont">
							<div class="new_onePublish text-ellipsis" @click="toNewsDetail(newPrveItem)">上一篇：{{newPrveItem && newPrveItem.title?newPrveItem.title:"暂无上一篇"}}</div>
							<div class="new_onePublish text-ellipsis" @click="toNewsDetail(newNextItem)">下一篇：{{newNextItem && newNextItem.title?newNextItem.title:"暂无下一篇"}}</div>
						</div>
						<el-tooltip class="item" effect="dark" :content="fileName" placement="top" v-if="fileName">
							<div class="new_publishDownload" @click="handleDownload">
								<img src="@/images/download.png" /><br /> 附件下载
							</div>
						</el-tooltip>
					</div>
				</div>

			</div>
		</div>
		<el-dialog title="我的反馈" class="open_dialogInfo" :visible.sync="back" width="540px" :close-on-click-modal="false">
			<div class="dialog_scroll dialog_padding clearfix">
				<el-input type="textarea" resize="none" :rows="6" placeholder="请输入内容" v-model="backinfo.backContext">
				</el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="back=false">取 消</el-button>
				<el-button type="primary" @click="backChapters">提 交</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { downloadFile } from "@/utils/oss.js";
	import { noticeGetById, noticeBackSave, userIsRead } from '@/api/notice'
	export default {
		name: 'newsdetail',
		data() {
			return {
				id: this.$route.query.id,
				backinfo: {
					backContext: '',
					noticeId: this.$route.query.id
				},
				detailInfo: {},
				fileName: null,
				back: false,
				dataloading: false,
				newPrveItem: null,
				newNextItem: null,
			}
		},
		created() {
			this.newsItem();
		},
		methods: {
			toNewsDetail(item) {
				if(item && item.id) {
					this.id = item.id;
					this.newsItem();
				}
			},
			newsItem() {
				userIsRead({notice_id: this.id});
				noticeGetById({
					notice_id: this.id
				}).then(res => {
					this.detailInfo = res.data;
					this.newPrveItem = res.data.lastNoticeVo;
					this.newNextItem = res.data.nextNoticeVo;
					if(this.detailInfo.fileUrl == null || this.detailInfo.fileUrl == undefined || this.detailInfo.fileUrl == '') {
						this.fileName = null
					} else {
						this.fileName = JSON.parse(this.detailInfo.fileUrl)[0].name
					}
				})
			},
			handleDownload() {
				if(this.detailInfo.fileUrl == null || this.detailInfo.fileUrl == undefined || this.detailInfo.fileUrl == '') {
					return this.$message({
						message: '未上传附件',
						type: 'warning'
					});
				}
				const file_url = this.detailInfo.fileUrl;
				var fileUrl = JSON.parse(file_url)[0].url;
				var fileName = JSON.parse(file_url)[0].name;
				downloadFile(fileUrl, fileName)
			},
			backChapters() {
				var backinfo = this.backinfo;
				if(backinfo.backContext && backinfo.backContext != '') {
					noticeBackSave(backinfo).then(res => {
						this.$message({
							message: '反馈成功!',
							type: 'success'
						});
						this.backinfo.backContext = ''
						this.back = false
					})
				} else {
					this.$message.error('请输入反馈内容！')
				}
			},
			toName(name) {
				if(this.$router.name != name) {
					this.$router.push({
						name: name
					})
				}
			},
		},
	}
</script>